<template>
  <div class="el-input">
    <span v-if="prefix" class="input-prefix">
      {{ prefix }}
    </span>
    <input
      ref="numberInput"
      :class="['el-input__inner', { 'with-prefix': prefix }]"
      :readonly="readOnly"
      v-on="$listeners"
      @keyup="onKeyup($event)"
    />
    <span v-if="suffix" class="input-suffix">
      {{ suffix }}
    </span>
  </div>
</template>

<script>
import NumberFormatter from '../../../filters/number'
import { get } from 'lodash'

/**
 * @class NumberInput
 *
 * @description This component renders a text input with formatting for number type
 */
export default {
  name: 'number-input',
  props: {
    integerDigits: {
      default: 15,
    },
    decimals: {
      default: 0,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    fieldValue: {
      default: null,
    },
    name: {
      type: String,
    },
    formats: {
      type: Object,
      default: () => ({}),
    },
  },
  data: function () {
    return {
      value: '',
    }
  },
  methods: {
    onKeyup($event) {
      const value = $event.target.value
      if (value.length == 0) {
        this.value = ''
        $event.preventDefault()
        return
      }
      if (value.length === 1 && value === '-') {
        this.value = '-'
        $event.preventDefault()
        return
      }
      if ($event.key == NumberFormatter.decimalSeparator) {
        $event.preventDefault()
        return
      }

      const tmp = NumberFormatter.parseFormatted(value)
      if (isNaN(tmp)) {
        $event.preventDefault()
        $event.target.value = this.value
        return
      } else {
        const formatted = NumberFormatter.formatNumberDecimal(tmp, this.integerDigits, this.decimals)
        this.value = tmp
        $event.target.value = formatted
        //increase cursor position
        if (formatted.length > value.length) {
          $event.target.selectionStart++
          $event.target.selectionEnd++
        }
        this.$emit('input', Object.assign({}, $event, { target: { value: this.value } }))
      }
    },
  },
  mounted: function () {
    this.$nextTick(function () {
      this.value = this.fieldValue
      this.$refs.numberInput.value = NumberFormatter.formatNumberDecimal(this.value, this.integerDigits, this.decimals)
    })
  },
  computed: {
    suffix() {
      return get(this.formats, 'suffix', null)
    },
    prefix() {
      return get(this.formats, 'prefix', null)
    },
  },
  watch: {
    value() {
      this.$emit('form-item-changed', { name: this.name, value: this.value })
    },
    fieldValue() {
      if (this.fieldValue !== '-') {
        this.value = this.fieldValue
        this.$refs.numberInput.value = NumberFormatter.formatNumberDecimal(
          this.fieldValue,
          this.integerDigits,
          this.decimals,
        )
      }
    },
  },
}
</script>
<style lang="scss" scoped>
[readonly] {
  background: $background-color-readonly !important;
  cursor:
    url('../../../assets/img/notallowed24.png') 2 2,
    not-allowed !important;
}
.el-input {
  position: relative;
}
.with-prefix {
  padding-left: 32px;
}
.input-prefix,
.input-suffix {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.input-prefix {
  left: 10px;
}
.input-suffix {
  right: 10px;
}
</style>
